module.exports = {
  forIn: require('./for-in'),
  has: require('./has'),
  hasKey: require('./has-key'),
  hasValue: require('./has-value'),
  keys: require('./keys'),
  isMatch: require('./is-match'),
  values: require('./values')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/object/index.js
// module id = 302
// module chunks = 0 1 2